export default "__VITE_ASSET__DlNkfgBu__"